import APIS from "../../constant/EndPoint";
import { Link } from "react-router-dom";
import Card from "../Reusable/Card";
import UnControlSwitch from "../Reusable/UnControlSwitch";
import usePostHook from "../../customHooks/usePostHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const UserProfile = (props: any) => {
  const { profile } = props;

  const { mutateAsync } = usePostHook({
    queryKey: ["."],
    navigateURL: "",
  });

  const handleUserStatusChange = async () => {
    const url = `${APIS.USER}${profile?.user}/change-active-status/`;
    let formData = {};
    try {
      await mutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <Card>
        <div className={tw`m-2`}>
          <table>
            <tbody>
              <tr>
                <td>Name</td>
                <td>:</td>
                <td>{profile?.name ?? profile?.full_name ?? "N/A"}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td>:</td>
                <td>{profile?.user_info?.email ?? profile?.email ?? "N/A"}</td>
              </tr>
              <tr>
                <td>Contact Number</td>
                <td>:</td>
                <td>{profile?.user_info?.mobile_number ?? "N/A"}</td>
              </tr>
            </tbody>
          </table>
          <div className={tw`w-full flex justify-between`}>
            <div className={tw`w-[150px] mt-6`}>
              <button
                type="button"
                className={tw`cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-primary ring-offset-1`}
                onClick={() =>
                  window.location.replace(
                    `/user-role/users#/edit/${profile?.user}`
                  )
                }
              >
                Edit
              </button>
            </div>
            <div>
              <UnControlSwitch
                value={profile?.user_info?.is_active}
                onChange={handleUserStatusChange}
              />
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};

export default UserProfile;
